import { render, staticRenderFns } from "./FaceCamera.vue?vue&type=template&id=529099c0&scoped=true&"
import script from "./FaceCamera.vue?vue&type=script&lang=js&"
export * from "./FaceCamera.vue?vue&type=script&lang=js&"
import style0 from "./FaceCamera.vue?vue&type=style&index=0&id=529099c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529099c0",
  null
  
)

export default component.exports